import { Country, api } from 'api';
import { queryCacheDuration } from 'const';
import { rtkQueryApi } from 'store/rtkQueryApi';

export const countriesApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getCountries: builder.query<Country[], number[] | undefined>({
      query: (regionIds) => {
        return api.country.getCountries({ regionIds });
      },
      keepUnusedDataFor: queryCacheDuration,
    }),
  }),
});

export const { useGetCountriesQuery } = countriesApi;
